import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Menu from './Menu';
import Mobilemenu from './Mobilemenu';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";


import logo from '../../assets/img/logo.png';

const Header = (props) => {
    const location = useLocation()
    return <HeaderComponent props={props} location={location}/>
}


class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navmethod: false,
        };
        this.openNav = this.openNav.bind(this);
        this.closeNav = this.closeNav.bind(this);
    }
    // Navigation
    openNav() {
        this.setState({
            navmethod: true
        });
    }
    closeNav() {
        this.setState({
            navmethod: false
        });
    }
    componentDidMount() {
        window.addEventListener('scroll', () => {
            this.setState({
                isTop: window.scrollY > 110
            });
        }, false);
    }
    render() {
        // const props = this.props.props
        const stickyheader = this.state.isTop ? 'sticky' : '';
        const color = this.props.props.color !== undefined ? this.props.props.color : "white";
        return (
            <Fragment>
                {/* Aside (Mobile Navigation) */}
                <aside className={classNames("sigma_aside sigma_aside-left", { "open": this.state.navmethod })}>
                    <Mobilemenu location={this.props.location} viewEcommerce={this.props.props.viewEcommerce ? false : true}/>
                </aside>
                <div className="sigma_aside-overlay aside-trigger-left" onClick={this.closeNav} />
                {/* Header Start */}
                <header className={`sigma_header header-1 can-sticky header-absolute header-dark ${stickyheader}`}>
                    {/* Middle Header Start */}
                    <div className="sigma_header-middle">
                        <div className="container">
                            <nav className="navbar">
                                {/* Logo Start */}
                                <div className="sigma_logo-wrapper">
                                    <Link className="navbar-brand" to="/" style={{display: "flex"}}>
                                        <img src={logo} alt="" style={{width: "60%"}}/>
                                        <h3 style={{marginTop: "18%", marginLeft: "-13%" , "fontSize": "20px", color: "black" }}>GEMS</h3>
                                    </Link>
                                </div>
                                {/* Logo End */}
                                {/* Menu */}
                                <Menu location={this.props.location} viewEcommerce={this.props.props.viewEcommerce ? false : true}/>
                                {/* <Menu /> */}
                                {/* Controls */}
                                {/* <Link to="/login" className="sigma_btn-custom btn-sm light btn-pill d-none d-lg-block">Login</Link> */}
                                {/* Mobile Toggler */}
                                <div className="aside-toggler style-2 aside-trigger-left" onClick={this.openNav}>
                                    <span />
                                    <span />
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </nav>
                        </div>
                    </div>
                    {/* Middle Header End */}
                </header>
                {/* Header End */}
            </Fragment>
        );
    }
}

export default Header;